<mat-tab-group disableRipple="true" mbnmAddClass="product-selector" mbnmAddClassSelector="mat-tab-header, .mat-tab-body-wrapper"
               *ngIf="groupedProducts.length > 0" [selectedIndex]="selectedTabIndex"
               (click)="$event.stopPropagation();" [ngClass]="{'hide-tabs': groupedProducts && groupedProducts.length == 1}"
               (selectedTabChange)="tabChanged($event)">
  @for (productGroup of groupedProducts; track productGroup; let i = $index) {
  <mat-tab>
    <ng-template mat-tab-label>
      <div>
        <img [alt]="'Product Group - ' + productGroup.title" *ngIf="productGroup.thumb" [src]="productGroup.thumb" />
        <div [innerHTML]="productGroup.title">
        </div>
        <div class="sale-badge" *ngIf="productGroup.hasSaleItems">
          SALE
        </div>
      </div>
    </ng-template>

    <div *ngIf="productGroup.products.length == 0" class="placeholder"></div>
    <div *ngIf="productGroup.products.length >= 1">
      <mat-grid-list [cols]="media.isMatched(BREAKPOINTS.Standard.XSmall) ? mobileCols : cols"
                     [rowHeight]="(media.isMatched(BREAKPOINTS.Standard.XSmall) ? mobileCols : cols) == 1 ? 85 : 185"
                     gutterSize="5"
                     *ngIf="i == 0 || productGroup.loadContent">
        @for (product of productGroup.products; track product) {
        <mat-grid-tile
          (click)="choose(product)" [ngClass]="{'disabled': product.disabled, 'selected': isSelected(product)}">
          <div class="wrapper" [ngClass]="{'no-thumb': !product.thumb, 'single-col': (media.isMatched(BREAKPOINTS.Standard.XSmall) ? mobileCols : cols) == 1}">
            <div class="thumb-block">
              <img [src]="product.thumb" *ngIf="product.thumb" [alt]="product.description" >
              <div class="sale" *ngIf="!product.fixedPrice && product.saleUnitPrice && product.saleUnitPrice < product.unitPrice">
                {{ 1 - product.saleUnitPrice / product.unitPrice | percent }} OFF
              </div>
              <div class="price" *ngIf="product.fixedPrice" [innerHtml]="product.fixedPrice | currency2"></div>
            </div>
            <div class="description-block">
              <label class="description" [innerHtml]="product.description"></label>
              <div class="long-description" [innerHtml]="product.longDescription"></div>
            </div>
            <mat-checkbox color="secondary" [ngModel]="isSelected(product)" *ngIf="(media.isMatched(BREAKPOINTS.Standard.XSmall) ? mobileCols : cols) == 1">
            </mat-checkbox>
          </div>
        </mat-grid-tile>
        }
      </mat-grid-list>
      <mat-spinner color="secondary" *ngIf="i > 0 && !productGroup.loadContent"></mat-spinner>
    </div>
  </mat-tab>
  }
</mat-tab-group>
<div class="none-available" *ngIf="groupedProducts.length == 0">
    {{ noProductsAvailableMessage }}
</div>
